/* QUICK-ADD DRAWER – final version
 * Works with Dawn & any theme that uses <cart-drawer>
 * --------------------------------------------------- */

console.log('✅ quick-add-drawer.js loaded');

document.addEventListener(
  'submit',
  async (e) => {
    const form = e.target.closest('form.card-quick-add');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    const btn = form.querySelector('button[type="submit"]');
    btn && (btn.disabled = true);

    try {
      /* 1 ▸ add the item + ask Shopify to render the drawer sections */
      const res = await fetch(
        '/cart/add?sections=cart-drawer,cart-icon-bubble',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        }
      );

      if (!res.ok) throw new Error(await res.text());

      const parsedState = await res.json(); // has .sections

/* 2 ▸ update drawer HTML */
const drawer = document.querySelector('cart-drawer');
if (drawer?.renderContents && parsedState) {
  drawer.renderContents(parsedState);
  drawer.open();
}

      /* 3 ▸ update cart badge */
      const badgeHTML = parsedState.sections['cart-icon-bubble'];
      if (badgeHTML) {
        document
          .querySelectorAll('[data-cart-count]')
          .forEach((el) => (el.outerHTML = badgeHTML));
      }

    } catch (err) {
      console.error('🛑 Quick-add error:', err);
    } finally {
      btn && (btn.disabled = false);
    }
  },
  true
);